import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ReLoginComponent } from 'src/app/modules/auth/re-login/re-login.component';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { ConstantConfig } from '../config/constant.config';
import { ClientDetailService } from '../services/client-detail-service';
import { UserService } from '../services/user.service';
import { AuthService } from './auth-service';
import { LocalStorageService } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class SessionExpiredService {
    private popupRef: any = null;
    private isLoginAsClient = false;
    private reloginPopupRef: any = null;
    constructor(
        private modalService: NgbModal,
        private translateService: TranslateService,
        private clientDetailService: ClientDetailService,
        private userService: UserService,
        private authService: AuthService,
        private localStorageService: LocalStorageService
    ) { }

    showPopup(): Promise<void> {
        const pathname = window.location.pathname; 
        const segments = pathname.split('/').filter(Boolean);
        if(segments?.length==1) return Promise.resolve();
        if(segments?.length==2 && segments[1]=="resetpin") return Promise.resolve();
        if (this.popupRef) return Promise.resolve();
        this.userService.setAuthToken('idle');
        this.modalService.dismissAll();
        return new Promise((resolve) => {
            const modalRef = this.modalService.open(ConfirmModalComponent, {
                centered: true,
                size: 'sm',
                backdrop: 'static',
                keyboard: false,
            });

            let message = this.translateService.instant(
                'Your session is expired please login as client'
            );

            if (this.clientDetailService?.clientDetail?.id) {
                message += ` ${this.translateService.instant('via Lendisoft')}`;
            }

            modalRef.componentInstance.confirmationYesButton =
                this.translateService.instant('Proceed');
            modalRef.componentInstance.showCloseButton = false;
            modalRef.componentInstance.showConfirmationNoButton = false;
            modalRef.componentInstance.confirmationMessage = `${message}.`;

            this.popupRef = modalRef;

            modalRef.result.finally(() => {
                this.popupRef = null;

                if (this.clientDetailService?.clientDetail?.id) {
                    window.location.href =
                        `/lendisoft/home/lendisoft-configuration/clients/edit/${this.clientDetailService?.clientDetail?.id}`;
                } else {
                    window.location.reload();
                }

                resolve();
            });
        });
    }

    reset(): void {
        this.popupRef = null;
        this.reloginPopupRef = null;
    }

    async handleUnauthenticatedSessionPopup(): Promise<boolean> {
        // determine login type
        this.isLoginAsClient = this.userService.getLoginType(
            this.clientDetailService?.clientDetail?.slug
        );

        if (!this.isLoginAsClient && this.authService.isTokenExpired() && this.authService.isAuthenticated()) {
            await this.openReloginModal();
            return false;
        }
        const lendiSoftToken = this.localStorageService.get('lendisoft' + "_" + ConstantConfig.AUTH_TOKEN);
        if (this.isLoginAsClient && !lendiSoftToken) {
            await this.showPopup();
            return false;
        }
        if (this.authService.isAuthenticated() &&
            !(this.isLoginAsClient && this.authService.isTokenExpired())) {
            return true;
        }
        // NOT login as client → reload & block
        if (!this.isLoginAsClient) {
            window.location.reload();
            return false;
        }

        //no token or token expired login as client → show popup & block
        await this.showPopup();
        return false;
    }

    async openReloginModal(): Promise<void> {
        if (this.reloginPopupRef) return Promise.resolve();
        return new Promise((resolve) => {
            this.userService.setAuthToken('idle');
            const modalRef: any = this.modalService.open(ReLoginComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'sm', keyboard: false, backdrop: 'static', windowClass: 'custom-relogin-modal' });
            let body: any = document.querySelector('body');
            body.classList.add("login-modal-show");
            this.reloginPopupRef = modalRef;
            modalRef.result.finally((userResponse: any) => {
                this.reloginPopupRef = null;
                if (userResponse) {
                    // after login
                    body.classList.remove("login-modal-show");
                }
                resolve();
            });
        });
    }
}
